<div class="input-group" style="width: 99%">
  <input type="text" class="form-control input-stream-font"
         placeholder="หมายเหตุ"
         [(ngModel)]="newComment"
         (keydown.enter)="handleEnterKey($event)">

  <div class="icon-btn d-inline comment-send-button"
       (click)="addComment()">
    <i class="fa fa-paper-plane fa-2x mt-1 darkblue-color"></i>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/core/comment/comment.component.html